/**
 * @file Input component for seconds
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import * as moment from 'moment';
import { InputNumberComponent } from '../input-number/input-number.component';
/**
 * The input component allows the user to give a duration in seconds
 * @export
 * @class InputSecondsComponent
 * @extends {InputNumberComponent}
 */
var InputSecondsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputSecondsComponent, _super);
    function InputSecondsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputSecondsComponent.prototype, "valueAsSeconds", {
        /**
         * Gets the value in seconds.
         * @type {number}
         * @memberOf InputSecondsComponent
         */
        get: function () {
            return this.seconds;
        },
        /**
         * Sets the value in seconds.
         * @memberOf InputSecondsComponent
         */
        set: function (val) {
            this.seconds = val;
            var iso = val === null ? 'PT0S' : val === 0 ? 'PT0S' : moment.duration(val, 'seconds').toISOString();
            if (this.value !== iso) {
                this.value = iso;
            }
        },
        enumerable: true,
        configurable: true
    });
    InputSecondsComponent.prototype.checkPasteValue = function (event) {
        var clipboardData = event.clipboardData;
        var pastedText = clipboardData.getData('text');
        var value = Number.parseInt(pastedText.replace(/[^0-9]/g, ''), 10);
        var input = event.target;
        if (Number.isNaN(value)) {
            input.value = '0';
            this.beep();
            event.preventDefault();
            return;
        }
        var max = Number.parseInt(input.max, 10);
        if (max < value) {
            value = max;
            this.beep();
        }
        var min = Number.parseInt(input.min, 10);
        if (min > value) {
            value = min;
            this.beep();
        }
        input.value = value.toString();
        if (pastedText !== value.toString()) {
            this.beep();
        }
        event.preventDefault();
    };
    /**
     * Suppressing of none number user input.
     * @param {KeyboardEvent} event The event when the user presses a key.
     * @returns {Boolean} True when accepted otherwise false.
     * @memberOf InputSecondsComponent
     */
    InputSecondsComponent.prototype.suppressInvalidKeys = function (event) {
        var input = event.target;
        if (event.key >= '0' && event.key <= '9') {
            if (input.max.length === (input.value + '').length) {
                this.beep();
                return false;
            }
            return true;
        }
        if (input.max.length === (input.value + '').length) {
            this.beep();
            return false;
        }
        return false;
    };
    /**
     * Clears leading zero's when user leaves the input.
     * @param {Event} event The event when the user leave the input.
     * @memberOf InputSecondsComponent
     */
    InputSecondsComponent.prototype.removeLeadingZeros = function (event) {
        var original = event.target['value'];
        var test = original + '';
        if (test.length === 0) {
            // Leeg veld is een niet geldigge waarde.
            // Oplossen.
            this.seconds = 0;
            this.value = 'PT0S';
            event.target['value'] = '0';
            return;
        }
        while (test.length > 0) {
            if (test[0] === '0') {
                test = test.substr(1);
            }
            else {
                if (original !== test) {
                    this.beep();
                }
                event.target['value'] = test;
                return;
            }
        }
    };
    /*
     * Sets the value also as duration.
     * @protected
     * @param {*} val The value to be set.
     * @memberOf InputSecondsComponent
     */
    InputSecondsComponent.prototype.setValue = function (val) {
        if (typeof val === 'string' && (val.length === 0 || val[0] === 'P')) {
            _super.prototype.setValue.call(this, val);
            this.seconds = val.length === 0 ? null : moment.duration(val).asSeconds();
        }
    };
    /**
     * Sound to alert the user to his mistake
     * @private
     * @memberOf InputSecondsComponent
     */
    InputSecondsComponent.prototype.beep = function () {
        // TODO: Consider finding a "Heeee asshole" sound to alert the user to his mistake.
        // tslint:disable-next-line:max-line-length
        var snd = new Audio('data:audio/wav;base64,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');
        snd.play();
    };
    return InputSecondsComponent;
}(InputNumberComponent));
export { InputSecondsComponent };
